import { Alert } from "@material-ui/lab";
import { isNull } from "App/utils/helpers";
import React from "react";

function WarningJurnal({ formData }) {
  if (!isNull(formData.penjualan_id)) {
    return (
      <Alert severity={formData.is_jurnal ? "success" : "error"}>
        {formData.is_jurnal
          ? "Jurnal dalam penjualan ini sudah terupdate"
          : "Jurnal dalam penjualan ini belum terupdate. Silahkan klik update/ kunci"}
      </Alert>
    );
  } else {
    return <></>;
  }
}

export default WarningJurnal;
